export class ImportExportButton {
  type: ButtonType;
  name: string;
  hidden?: boolean;
  by?: ExportTypeEnum | ImportTypeEnum;
}

export enum ButtonType {
  IMPORT = 'import',
  IMPORT_ADDITIONAL = 'import-additional',
  EXPORT = 'export',
  EXPORT_ADDITIONAL = 'export-additional'
}

export enum ExportTypeEnum {
  PRODUCT = 'product',
  LOCATION = 'location',
  STORE = 'store',
  CARD = 'card'
}

export enum ImportTypeEnum {
  ITEM = 'item',
  SHELF = 'shelf'
}
